import { ProgramContentType } from "./BlockComponent";

export interface ProgramType {
  taskId: string;
  title?: string;
  isKeyActivity?: boolean;
  content: ProgramContentType[];
  translationVersion?: string;
  thoughtRecordKey?: string;
}

// TaskMetaData — 클라이언트 측 taskId 유효성 검증 (isTaskIdValid) 및 title 매핑용.
// group 은 ===== <name> ===== 주석으로 묶인 섹션 이름을 모든 항목에 명시한다.
export const TaskMetaData: { taskId: string; title: string; group?: string }[] =
  [
    // ===== 입문 =====
    { taskId: "10-1-A", title: "변화의 시작", group: "입문" },
    { taskId: "10-2-A", title: "거리두기란 무엇인가", group: "입문" },
    { taskId: "10-3-A", title: "목표 설정하기", group: "입문" },

    { taskId: "11-1-A", title: "인지하기란 무엇인가", group: "입문" },
    { taskId: "11-2-A", title: "경험 분리 훈련", group: "입문" },
    { taskId: "11-3-A", title: "경험 분리 훈련 - 상황", group: "입문" },

    { taskId: "12-1-A", title: "복습: 거리두기에 대하여", group: "입문" },
    { taskId: "12-2-A", title: "경험 분리 훈련 - 생각", group: "입문" },
    {
      taskId: "12-3-A",
      title: "경험 분리 훈련 - 감정/신체 반응",
      group: "입문",
    },

    { taskId: "13-1-A", title: "경험 분리 훈련 - 행동", group: "입문" },
    { taskId: "13-2-A", title: "복습: 경험 분리에 대하여", group: "입문" },

    // ===== 거리두기 =====
    { taskId: "0-7-A", title: "첫 번째 생각 기록", group: "거리두기" },
    { taskId: "1-1-A", title: "나의 고민과 목표", group: "거리두기" },
    { taskId: "2-3-A", title: "꾸러미 분리하기", group: "거리두기" },
    { taskId: "2-4-A", title: "분리 연습하기", group: "거리두기" },

    { taskId: "0-1-A", title: "부정적 반응 측정하기", group: "거리두기" },
    { taskId: "1-2-A", title: "프로그램 구성하기", group: "거리두기" },

    { taskId: "1-3-A", title: "생각과 팝콘과 나", group: "거리두기" },
    { taskId: "8-1-A", title: "생각과 다시 관계 맺기", group: "거리두기" },
    { taskId: "8-2-A", title: "첫 번째 명상 훈련", group: "거리두기" },
    { taskId: "14-1-A", title: "주의 통제 훈련", group: "거리두기" },

    { taskId: "8-3-A", title: "두 번째 명상 훈련", group: "거리두기" },
    { taskId: "8-10-A", title: "레몬 맛 팝콘", group: "거리두기" },

    { taskId: "8-4-A", title: "세 번째 명상 훈련", group: "거리두기" },

    { taskId: "8-5-A", title: "네 번째 명상 훈련", group: "거리두기" },
    { taskId: "8-6-A", title: "훈련 루틴 만들기", group: "거리두기" },

    { taskId: "8-8-A", title: "감정과 신체 다스리기", group: "거리두기" },

    { taskId: "8-9-A", title: "생각에서 빠져나오기", group: "거리두기" },

    // ===== 생각함정 =====
    { taskId: "3-2-A", title: "자동적인 생각", group: "생각함정" },
    { taskId: "3-3-A", title: "자동적 사고 살펴보기", group: "생각함정" },

    { taskId: "4-1-A", title: "생각함정", group: "생각함정" },
    {
      taskId: "4-2-A",
      title: "다양한 관점에서 생각해보기",
      group: "생각함정",
    },

    { taskId: "4-4-1-A", title: "생각함정 1: 책임 과다", group: "생각함정" },
    { taskId: "4-4-2-A", title: "생각함정 2: 근거 부족", group: "생각함정" },
    { taskId: "4-4-3-A", title: "생각함정 3: 부정 편향", group: "생각함정" },
    { taskId: "4-4-4-A", title: "생각함정 4. 평가", group: "생각함정" },
    { taskId: "4-4-5-A", title: "생각함정 5. 개념화", group: "생각함정" },
    { taskId: "4-4-6-A", title: "생각함정 6. 반추", group: "생각함정" },
    { taskId: "4-5-1-A", title: "책임 과다 다루기", group: "생각함정" },
    { taskId: "4-5-2-A", title: "근거 부족 다루기", group: "생각함정" },
    { taskId: "4-5-3-A", title: "부정 편향 다루기", group: "생각함정" },
    { taskId: "4-5-4-A", title: "평가 다루기", group: "생각함정" },
    { taskId: "4-5-5-A", title: "개념화 다루기", group: "생각함정" },
    { taskId: "4-5-6-A", title: "반추 다루기", group: "생각함정" },

    // ===== 기꺼이 경험하기 =====
    { taskId: "9-1-A", title: "마음과 문제 해결", group: "기꺼이 경험하기" },
    { taskId: "9-2-A", title: "나의 지난 노력들", group: "기꺼이 경험하기" },

    { taskId: "9-3-A", title: "기꺼이 경험하기", group: "기꺼이 경험하기" },
    {
      taskId: "9-4-A",
      title: "적극적 관찰자 되기 - 상황",
      group: "기꺼이 경험하기",
    },
    {
      taskId: "9-5-A",
      title: "기꺼이 경험하며 기록하기 - 상황",
      group: "기꺼이 경험하기",
    },

    {
      taskId: "9-6-A",
      title: "적극적 관찰자 되기 - 감정",
      group: "기꺼이 경험하기",
    },
    {
      taskId: "9-7-A",
      title: "기꺼이 경험하며 기록하기 - 감정",
      group: "기꺼이 경험하기",
    },

    {
      taskId: "9-8-A",
      title: "적극적 관찰자 되기 - 신체 반응",
      group: "기꺼이 경험하기",
    },
    {
      taskId: "9-9-A",
      title: "기꺼이 경험하며 기록하기 - 신체 반응",
      group: "기꺼이 경험하기",
    },

    {
      taskId: "9-10-A",
      title: "적극적 관찰자 되기 - 행동",
      group: "기꺼이 경험하기",
    },
    {
      taskId: "9-11-A",
      title: "기꺼이 경험하며 기록하기 - 행동",
      group: "기꺼이 경험하기",
    },

    { taskId: "9-12-A", title: "몸의 감각 느끼기", group: "기꺼이 경험하기" },
    {
      taskId: "9-13-A",
      title: "어려움을 기꺼이 경험하기",
      group: "기꺼이 경험하기",
    },

    // ===== 가치 =====
    { taskId: "7-1-A", title: "긍정 기록 시작하기", group: "가치" },
    { taskId: "7-2-A", title: "나의 첫 번째 긍정 기록", group: "가치" },

    { taskId: "7-3-A", title: "삶의 방향 선택하기", group: "가치" },
    { taskId: "7-4-A", title: "가치 살펴보기", group: "가치" },

    { taskId: "7-5-A", title: "가치 행동", group: "가치" },
    { taskId: "7-6-A", title: "가치 행동 설계하기", group: "가치" },

    // n 은 단계 숫자 placeholder (logics.ts getTaskTitleFromTaskId 의 .replace("n", N) 에서 치환)
    { taskId: "7-7-A", title: "가치 행동 n단계 계획하기", group: "가치" },
    { taskId: "7-8-A", title: "가치 행동 n단계 실행하기", group: "가치" },

    { taskId: "7-9-A", title: "가치 정리하기", group: "가치" },

    // ===== 믿음 =====
    { taskId: "6-1-A", title: "생각 그물", group: "믿음" },
    { taskId: "6-2-A", title: "중간 믿음", group: "믿음" },
    { taskId: "6-3-A", title: "중간 믿음 살펴보기", group: "믿음" },

    { taskId: "6-4-A", title: "핵심 믿음", group: "믿음" },
    { taskId: "6-6-A", title: "핵심 믿음 살펴보기", group: "믿음" },

    { taskId: "6-7-A", title: "핵심 경험", group: "믿음" },
    { taskId: "6-8-A", title: "핵심 경험 살펴보기", group: "믿음" },

    { taskId: "6-9-A", title: "생각 그물 이해하기", group: "믿음" },
    { taskId: "6-10-A", title: "대처 전략과 중간 믿음", group: "믿음" },

    { taskId: "6-11-A", title: "생각 그물과 가치", group: "믿음" },
    { taskId: "6-12-A", title: "생각 그물과 거리두기", group: "믿음" },

    {
      taskId: "6-13-A",
      title: "생각과 거리두고 가치로 나아가기",
      group: "믿음",
    },

    // ===== 주차별 점검 =====
    { taskId: "0-2-A", title: "부정적 반응 측정하기", group: "주차별 점검" },
    { taskId: "0-3-A", title: "이번 주 돌아보기", group: "주차별 점검" },
    { taskId: "0-3-W", title: "N주차 돌아보기", group: "주차별 점검" },

    // ===== 기타 =====
    { taskId: "0-8-A", title: "프로그램 범위 점검하기", group: "기타" },
    { taskId: "90-1-A", title: "X요일의 명상 훈련", group: "기타" },

    // ===== 도구 =====
    { taskId: "2-2-T", title: "생각기록지", group: "도구" },
    { taskId: "5-7-T", title: "명상훈련지", group: "도구" },
  ];

export function isTaskIdValid(taskId: string) {
  const taskIndex = TaskMetaData.findIndex(
    (element) => element.taskId === taskId
  );
  return taskIndex > -1;
}
